export default __webpack_public_path__ + "static/media/judith.1e0690b0.jpg";